import axiosInstance from "../../lib/axiosInstance";
import { AppDispatch } from "../store";
import { currencyActions } from "../slices/currency";
import { getErrorMessage } from "../../utils/errorUtils";
import { CurrencyResponseDto } from "../../shared/dtos/currency/CurrencyResponseDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getCurrencies = () => async (dispatch: AppDispatch) => {
  dispatch(currencyActions.setLoading());
  try {
    const { data } = await axiosInstance.get<
      ApiResponseDto<CurrencyResponseDto[]>
    >("/currencies", {
      headers: { requiresAuth: true },
    });

    if (data.status === ApiResponseStatus.SUCCESS && data.data) {
      dispatch(currencyActions.setItems(data.data));
    }
  } catch (error) {
    dispatch(currencyActions.setError(getErrorMessage(error)));
  }
};
